<bw-action-article-legacy [brightsideWebFb]="{event_name: 'notifications_shown'}">
  <typography-legacy header-title title-medium>{{ 'NOTIFICATIONS' |  translate }}</typography-legacy>
 <div content-section>
   <div *ngIf="groupedNotifications$ | async as grouped;">
     <ng-container *ngIf="grouped.alerts.length !== 0 || grouped.others.length !== 0; else noNotifications">
       <section class="notifications urgent-notifications"
        *ngIf="grouped.urgent.length > 0">
         <brightside-web-urgent-notification
            *ngFor="let notification of grouped.urgent"
            [notificationItem]="notification">
         </brightside-web-urgent-notification>
       </section>
       <section class="notifications alert-notifications"
                *ngIf="grouped.alerts.length > 0">
         <brightside-web-alert-action
           *ngFor="let notification of grouped.alerts"
           [notificationItem]="notification"
         ></brightside-web-alert-action>
       </section>
       <section class="notifications non-alert-notifications">
         <ng-container *ngFor="let notification of grouped.others">
           <ng-container [ngSwitch]="notification.type">
             <brightside-web-info *ngSwitchCase="'INFO'" [notificationItem]="notification" />
             <brightside-web-info-action *ngSwitchCase="'INFO_ACTION'" [notificationItem]="notification" />
           </ng-container>
         </ng-container>
       </section>
     </ng-container>
   </div>
 </div>
</bw-action-article-legacy>

<ng-template #noNotifications>
  <ng-lottie
    width="200px"
    height="200px"
    containerClass="notification-bell mr-xs"
    [options]="noNotificationsAnimation"
  ></ng-lottie>
  <typography-legacy text-medium-semibold>
    {{ 'NO_NOTIFICATIONS_TITLE' | translate }}
  </typography-legacy>
  {{ 'NO_NOTIFICATIONS_DESC' | translate }}
</ng-template>
